import { DynamoKey } from "./BaseDynamoClass";
import { UnderscoreKeys } from "../util/Types";
import { BasicError } from "./BasicError";
import { User, UserPKInput } from "./User";
import { UserOwnedClass, UserOwnedFields } from "./UserOwnedClass";

export type WsConnectionFields = UserOwnedFields & {
	connectionId: string;
	parentTable: string;
	expiresAt: number;
};
export class WsConnection<TFields extends WsConnectionFields = WsConnectionFields> extends UserOwnedClass<TFields> {
	_connectionId!: string;
	_parentTable!: string;
	_expiresAt: number;
	override _className: string = "WsConnection";
	override _deserializeClassName: string = "WsConnection";

	override getFieldList(): (keyof UnderscoreKeys<TFields>)[] {
		return [...super.getFieldList(), "_connectionId", "_parentTable", "_expiresAt"];
	}
	constructor(props: Partial<TFields>) {
		super(props);
		this._expiresAt = (Date.now() + 86400000) / 1000;
	}
	get connectionId(): string {
		return this.checkFieldType<"connectionId">(this._connectionId);
	}
	set connectionId(value: string) {
		this._connectionId = this.checkFieldTypeAndMark<"connectionId">("_connectionId", value);
	}

	get parentTable(): string {
		return this.checkFieldType<"parentTable">(this._parentTable);
	}
	set parentTable(value: string) {
		this._parentTable = this.checkFieldTypeAndMark<"parentTable">("_parentTable", value);
	}

	get expiresAt(): number {
		return this.checkFieldType<"expiresAt">(this._expiresAt);
	}
	set expiresAt(value: number) {
		this._expiresAt = this.checkFieldTypeAndMark<"expiresAt">("_expiresAt", value);
	}

	getPKPrefix(): string {
		return "USER#";
	}
	getSKPrefix(props: object | undefined): string {
		return "CONNECTION#";
	}
	getPK(): string {
		return this.getPKPrefix() + this.userId;
	}
	getSK(): string {
		return this.getSKPrefix(this) + this._connectionId;
	}
	getParentKey(): DynamoKey | undefined {
		return User.generateKey({ userId: this.userId });
	}
	getParentKeyInput(): UserPKInput | undefined {
		if (!this.userId) throw new BasicError("Missing userId", "Missing userId");
		return { userId: this.userId };
	}
	getParentTableName(): string | undefined {
		return this._parentTable;
	}
	generateKey(input: any): DynamoKey {
		return {
			PK: this.getPK(),
			SK: this.getSKPrefix(input) + this._connectionId,
		};
	}
	generatePK(input: UserPKInput): string {
		return this.getPKPrefix() + input.userId;
	}
	generateGSIPK(index: number, key: object): string {
		throw new BasicError("Not implemented", "Method not implemented.");
	}
	generateGSISK(index: number, key: object | undefined): string {
		throw new BasicError("Not implemented", "Method not implemented.");
	}
	getGlobalIndices(): object {
		return {};
	}
	getColumnsForExport(): string[] {
		throw new BasicError("Not implemented", "Method not implemented.");
	}
	getObjectForExport(): object {
		throw new BasicError("Not implemented", "Method not implemented.");
	}
}
